import React, { useState, useEffect, useRef } from 'react'
import logo from '../Images/Sample.png'
import 'bootstrap'
import './Navbar.css'
import { useSelector } from 'react-redux'
import { Store } from './store/store'
import { BrowserRouter as Router, Link, NavLink, Navigate } from "react-router-dom";
import { textAlign } from '@mui/system'
import { auth } from "./Firebase";
import { getAuth } from "firebase/auth";
import { useDetectScroll } from "@smakss/react-scroll-direction";
import { update } from 'firebase/database'
import { useScrollPosition } from 'react-use-scroll-position';


export default function Navbar({name}) {
  const [color, setColor] = useState('rgba(255,255,255,0.45)')
  const [position, setPosition] = useState('rgb(0,0,0,0.6)')
  const [scrollDir] = useDetectScroll({});

  const colorWhite = (x)=>{
    setColor('white')
    // x.style.color = "white";
  }
  const colorNormal = (x)=>{
    setColor('rgba(255,255,255,0.45)')
    // x.style.color = "rgba(255,255,255,0.45)";
  }

  const { x, y } = useScrollPosition();
window.onscroll = function() {
  if (y >= 50 ) {
    setPosition('rgb(0,0,0,1)')
  }
  else if (y >= 40 ) {
    setPosition('rgb(0,0,0,0.9)')
  }
  else if (y >=30 ) {
    setPosition('rgb(0,0,0,0.8)')
  }
  else if (y >=20 ) {
    setPosition('rgb(0,0,0,0.7)')
  }
  else if(y == 0){
    setPosition('rgb(0,0,0,0.6)')
  }
  else{
    setPosition('rgb(0,0,0,0.6)')
  }
}
  
  const cartItems = useSelector(state => state.cartReducer.cartItems);
  const Total = useSelector(state => state.cartReducer.total);
  return (
    <div className='nav col-md-12 w-100 autohide'
     style={{position: 'fixed',zIndex: "1",top: '0px',width: "100%",transition: "all 0.3s ease-in-out"}}>
        <nav className="autohide navbar navbar-expand-lg" 
        style={{backgroundColor: position,color: 'rgba(255, 255, 255, 0.304)'}} >
    <div className="container-fluid my-2">

      <img src={logo} className="mx-3 logo"></img>
      <h2 className='navbar-brand' >
      <Link to={'/'} className="navbar-brand col-md-9 navbar-brand"
      style={{fontSize: "2rem",color: "white"}} >Dabaagh</Link>
      </h2>
      <button className="navbar-toggler" type="button" data-toggle="collapse"
       style={{border: "1px solid white"}}
       data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
       aria-expanded="false" aria-label="Toggle navigation">
    <span className="material-symbols-outlined" style={{color: "white"}}>
menu
</span>
        </button>
      <div className="collapse navbar-collapse col-md-6" id="navbarSupportedContent"
      style={{marginRight: "0"}}>
        <ul className="navbar-nav me-auto mb-2 mb-lg-0 nav-ul">
          <li className="nav-item">
            <Link to='/' exac="true" className="nav-a nav-a " aria-current="page" >Home</Link>
          </li>
      <li className="nav-item">
            <Link to='/story' className="nav-a nav-a" >Our Story</Link>
          </li>
          <li className="nav-item">
            <Link to='/shop' className="nav-a nav-a " >Shop</Link>
          </li>
          <li className="nav-item">
            <Link to='/get-in-touch' className="nav-a nav-a " 
             >Get in Touch</Link>
          </li>
      <li className="nav-item dropdown" style={{color: "rgba(255, 255, 255, 0.45)"}}>
        <a className={`nav-link dropdown-toggle`} style={{color: color}}
         id="navbarDarkDropdownMenuLink" role="button" data-toggle="dropdown"
          onMouseEnter={() => colorWhite(this)}
          onMouseLeave={() => colorNormal(this)}
         aria-haspopup="true" aria-expanded="false"  >
          Policies
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDarkDropdownMenuLink"
        style={{backgroundColor: "rgba(0,0,0,0.6)",color: "white",top: "120%"}}>
          <Link to='/return-policy' className="dropdown-item nav-b" href="#">Return Policy</Link>
          <Link to='/return-policy' className="dropdown-item nav-b" href="#">Other Policies</Link>
        </div>
      </li>
          <li className="nav-item">
            {name ? 
            <>
            <Link to='/user' className="nav-a nav-a ">{name}</Link>
            </>: 
            <>
            <Link to='/login' className="nav-a nav-a " ><span className="material-symbols-outlined"
            style={{verticalAlign: "middle"}}>account_circle
            </span> Login</Link>
            </>
             }
          </li>
          <li className="nav-item dropdown">
        <Link to='/cart' className="nav-a">
          <span className="material-symbols-outlined mx-2" style={{color: "white"}}>
          shopping_cart
          </span>
        </Link>
      </li>
        </ul>
      </div>
    </div>
  </nav>
    </div>
  )
}

      //     <ul style={{listStyle: "none"}}>
      //       <li>
      //         <span>Name</span> <span>Quantity</span> <span>Price</span>
      //       </li>
      //   {cartItems.map(item => (
      //     <li key={item.id}>
      //     <span>{item.name}</span> <span>({item.quantity})</span>   
      //     </li>
      //   ))}
      //   <li>
      //     Total: ${Total}
      //   </li>
      // </ul>